module.exports = __webpack_public_path__ + "static/img/csi4.bd201903.png";